const enc = new TextEncoder();

function randomString(length) {
    let result = "";
    const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
}
async function sha256(str) {
    return new Uint8Array(
        await crypto.subtle.digest("SHA-256", enc.encode(str))
    );
}
function toHex(uint8Array) {
    const hashArray = Array.from(uint8Array);
    const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
    return hashHex;
}
function hexToBase64(str) {
    return btoa(
        String.fromCharCode.apply(
            null,
            str
                .replace(/\r|\n/g, "")
                .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
                .replace(/ +$/, "")
                .split(" ")
        )
    );
}

function replaceSpecialCharacter(challengeCode) {
    return challengeCode
        .replace(/[\\+]/g, "-")
        .replace(/[\\/]/g, "_")
        .replace(/[=]/g, "")
}

export { randomString, sha256, toHex, hexToBase64, replaceSpecialCharacter };